/**
 * Offer landing — variant pickers, volume tiers, choice groups (cart-sheet style)
 */
(function () {
  'use strict';

  var O = window.MMOffers || {};

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function variantImageUrl(product, variant) {
    if (variant && variant.featured_image) {
      return typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image.src || '');
    }
    if (variant && product && product.images && product.images.length) {
      for (var i = 0; i < product.images.length; i++) {
        var img = product.images[i];
        if (img.variant_ids && img.variant_ids.indexOf(variant.id) >= 0) return img.src;
      }
    }
    return product && product.featured_image ? product.featured_image : '';
  }

  function setGalleryImage(url) {
    if (!url) return;
    var main = document.getElementById('mm-op-gallery-main-img');
    if (main) {
      main.src = url;
      return;
    }
    var hero = document.getElementById('mm-op-prod-hero');
    if (hero) hero.innerHTML = '<img src="' + esc(url) + '" alt="" id="mm-op-gallery-main-img">';
  }

  function filterVariants(product, option) {
    var variants = (product && product.variants) || [];
    if (!option || option.variantMode !== 'specific') return variants;
    var validIds = (option.selectedVariantIds || (option.selectedVariantId ? [option.selectedVariantId] : []))
      .map(function (id) { return String(id).split('/').pop(); });
    if (!validIds.length) return variants;
    var filtered = variants.filter(function (v) { return validIds.indexOf(String(v.id)) > -1; });
    return filtered.length ? filtered : variants.slice(0, 1);
  }

  function updatePickerThumb(picker, product, variant) {
    if (!picker || !product) return;
    var row = picker.closest('.mm-op-variant-row');
    if (!row) return;
    var thumb = row.querySelector('[data-mm-op-variant-thumb]');
    if (!thumb) return;
    var url = variantImageUrl(product, variant);
    if (url) thumb.src = url;
  }

  function buildVariantMenuHtml(variants, activeId, product) {
    return variants.map(function (v) {
      var active = String(v.id) === String(activeId) ? ' is-active' : '';
      var disabled = v.available === false ? ' is-disabled' : '';
      var imgUrl = product ? variantImageUrl(product, v) : '';
      var imgHtml = imgUrl
        ? '<img class="mm-op-variant-option-img" src="' + esc(imgUrl) + '" alt="" loading="lazy">'
        : '';
      return '<button type="button" class="mm-op-variant-option' + active + disabled + '" data-variant-id="' + v.id + '" data-price="' + v.price + '"' +
        (v.available === false ? ' disabled' : '') + ' role="option" aria-selected="' + (active ? 'true' : 'false') + '">' +
        imgHtml +
        '<span class="mm-op-variant-option-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></span>' +
        '<span class="mm-op-variant-option-title">' + esc(v.title) + '</span>' +
        '</button>';
    }).join('');
  }

  function buildVariantPickerHtml(opts) {
    var variants = opts.variants || [];
    var product = opts.product || null;
    if (variants.length <= 1) {
      var only = variants[0];
      if (only && only.title !== 'Default Title') {
        var onlyThumb = product ? variantImageUrl(product, only) : '';
        return '<div class="mm-op-variant-row">' +
          (onlyThumb ? '<img src="' + esc(onlyThumb) + '" class="mm-op-variant-thumb" data-mm-op-variant-thumb alt="">' : '') +
          '<div class="mm-op-variant-static">' + esc(only.title) + '</div></div>';
      }
      return '';
    }
    var active = variants.find(function (v) { return String(v.id) === String(opts.selectedId); }) || variants[0];
    var hint = opts.hint || '';
    var thumbUrl = variantImageUrl(product, active);
    return '<div class="mm-op-variant-row">' +
      (thumbUrl ? '<img src="' + esc(thumbUrl) + '" class="mm-op-variant-thumb" data-mm-op-variant-thumb alt="">' : '') +
      '<div class="mm-op-variant-picker" data-mm-op-variant-picker data-idx="' + opts.idx + '" data-selected-id="' + active.id + '"' +
      (opts.slot ? ' data-slot="' + opts.slot + '"' : '') + '>' +
      '<button type="button" class="mm-op-variant-trigger" data-mm-op-variant-toggle aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="mm-op-variant-trigger-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg></span>' +
        '<span class="mm-op-variant-trigger-text">' +
          '<span class="mm-op-variant-trigger-label" data-mm-op-variant-label>' + esc(active.title) + '</span>' +
          (hint ? '<span class="mm-op-variant-trigger-hint">' + esc(hint) + '</span>' : '') +
        '</span>' +
        '<span class="mm-op-variant-trigger-chevron" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg></span>' +
      '</button>' +
      '<div class="mm-op-variant-menu" data-mm-op-variant-menu hidden role="listbox">' +
        buildVariantMenuHtml(variants, active.id, product) +
      '</div>' +
    '</div></div>';
  }

  function pickerFloatRoot() {
    return document.querySelector('.mm-op-wrapper') || document.body;
  }

  function dockPickerMenu(picker) {
    if (!picker) return;
    var menu = picker._floatMenu || picker.querySelector('[data-mm-op-variant-menu]');
    if (!menu) return;
    menu.classList.remove('is-floating', 'is-flip-up');
    menu.hidden = true;
    menu.style.cssText = '';
    if (menu.parentNode !== picker) picker.appendChild(menu);
    delete picker._floatMenu;
  }

  function closePicker(picker) {
    if (!picker) return;
    picker.classList.remove('is-open');
    dockPickerMenu(picker);
    var t = picker.querySelector('[data-mm-op-variant-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function closeAllPickers(except) {
    document.querySelectorAll('[data-mm-op-variant-picker].is-open').forEach(function (p) {
      if (except && p === except) return;
      closePicker(p);
    });
  }

  function positionFloatingMenu(menu, trigger) {
    if (!menu || !trigger) return;
    var rect = trigger.getBoundingClientRect();
    var gap = 4;
    var maxH = Math.min(220, Math.round(window.innerHeight * 0.36));
    menu.style.position = 'fixed';
    menu.style.left = Math.max(8, rect.left) + 'px';
    menu.style.width = Math.min(rect.width, window.innerWidth - 16) + 'px';
    menu.style.maxHeight = maxH + 'px';
    menu.style.zIndex = '2147483647';
    menu.style.right = 'auto';

    menu.style.visibility = 'hidden';
    menu.style.display = 'block';
    var menuH = menu.scrollHeight || maxH;
    menu.style.visibility = '';

    var spaceBelow = window.innerHeight - rect.bottom - gap;
    var spaceAbove = rect.top - gap;
    if (spaceBelow < Math.min(menuH, maxH) + 8 && spaceAbove > spaceBelow) {
      menu.classList.add('is-flip-up');
      menu.style.top = 'auto';
      menu.style.bottom = (window.innerHeight - rect.top + gap) + 'px';
    } else {
      menu.classList.remove('is-flip-up');
      menu.style.bottom = 'auto';
      menu.style.top = (rect.bottom + gap) + 'px';
    }
  }

  function openPicker(picker) {
    var menu = picker.querySelector('[data-mm-op-variant-menu]');
    var toggle = picker.querySelector('[data-mm-op-variant-toggle]');
    if (!menu || !toggle || !menu.children.length) return;

    closeAllPickers();
    picker.classList.add('is-open');
    picker._floatMenu = menu;
    pickerFloatRoot().appendChild(menu);
    menu.classList.add('is-floating');
    menu.hidden = false;
    menu.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      positionFloatingMenu(menu, toggle);
    });
  }

  function wireVariantPickers(root, ctx) {
    if (!root) return;
    root.querySelectorAll('[data-mm-op-variant-picker]').forEach(function (picker) {
      if (picker.getAttribute('data-mm-op-wired') === '1') return;
      picker.setAttribute('data-mm-op-wired', '1');
      var toggle = picker.querySelector('[data-mm-op-variant-toggle]');
      var menu = picker.querySelector('[data-mm-op-variant-menu]');
      if (!toggle || !menu) return;

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (picker.classList.contains('is-open')) closePicker(picker);
        else openPicker(picker);
      });

      menu.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-variant-id]');
        if (!btn || btn.disabled) return;
        e.stopPropagation();
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        var price = parseInt(btn.getAttribute('data-price'), 10);
        var label = picker.querySelector('[data-mm-op-variant-label]');
        if (label) {
          var titleEl = btn.querySelector('.mm-op-variant-option-title');
          if (titleEl) label.textContent = titleEl.textContent;
        }
        menu.querySelectorAll('.mm-op-variant-option').forEach(function (o) {
          o.classList.toggle('is-active', o === btn);
          o.setAttribute('aria-selected', o === btn ? 'true' : 'false');
        });
        closePicker(picker);
        picker.setAttribute('data-selected-id', String(vid));
        if (ctx && ctx.product) {
          var selVar = (ctx.variants || []).find(function (vr) { return String(vr.id) === String(vid); });
          if (selVar) updatePickerThumb(picker, ctx.product, selVar);
        }
        if (ctx && ctx.onSelect) ctx.onSelect(picker, vid, price, btn);
      });
    });

    if (!window.__mmOpPickerDocClose) {
      window.__mmOpPickerDocClose = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-mm-op-variant-picker]') ||
            e.target.closest('[data-mm-op-variant-menu].is-floating')) return;
        closeAllPickers();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAllPickers();
      });
      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-mm-op-variant-picker].is-open').forEach(function (picker) {
          var menu = picker._floatMenu;
          var toggle = picker.querySelector('[data-mm-op-variant-toggle]');
          if (menu && menu.classList.contains('is-floating') && toggle) {
            positionFloatingMenu(menu, toggle);
          }
        });
      });
    }
  }

  function buildChoiceGroupHtml(opts) {
    var products = opts.products || [];
    var item = opts.item || {};
    var idx = opts.idx;
    var L = opts.labels || {};
    var title = item.label || L.chooseOneProduct || 'Pick one product';
    var cards = products.map(function (cp, oi) {
      var active = oi === 0 ? ' is-active' : '';
      return '<button type="button" class="mm-op-choice-card' + active + '" data-choice-idx="' + idx + '" data-option="' + oi + '" aria-pressed="' + (oi === 0 ? 'true' : 'false') + '">' +
        '<img src="' + esc(cp.featured_image) + '" alt="" class="mm-op-choice-card__img">' +
        '<span class="mm-op-choice-card__name">' + esc(cp.title) + '</span>' +
        '<span class="mm-op-choice-card__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></span>' +
      '</button>';
    }).join('');

    return '<div class="mm-op-choice-block" data-choice-block="' + idx + '">' +
      '<div class="mm-op-step-label"><span class="mm-op-step-num">1</span>' + esc(title) + '</div>' +
      '<div class="mm-op-choice-grid">' + cards + '</div>' +
      '<div class="mm-op-step-label mm-op-step-label--flavor"><span class="mm-op-step-num">2</span>' + esc(L.thenChooseFlavour || 'Then choose flavour') + '</div>' +
      '<div class="mm-op-variant-slot" data-idx="' + idx + '"></div>' +
    '</div>';
  }

  function buildFixedListHtml(variants, L) {
    return '<div class="mm-op-fixed-list"><div class="mm-op-fixed-header">' + esc(L.includedFlavors || 'Included flavours') + '</div>' +
      variants.map(function (v) { return '<div class="mm-op-fixed-item">' + esc(v.title) + '</div>'; }).join('') +
    '</div>';
  }

  function volRadioHtml(checked) {
    return '<div class="mm-vol-radio" aria-hidden="true"><div class="mm-vol-radio-dot"></div></div>' +
      '<input type="radio" class="mm-vol-radio-input"' + (checked ? ' checked' : '') + ' tabindex="-1" aria-hidden="true">';
  }

  function volTierRow(opts) {
    var qty = opts.qty;
    var ar = opts.ar;
    var unitOne = opts.unitOne || (ar ? 'قطعة' : 'piece');
    var unitMany = opts.unitMany || (ar ? 'قطع' : 'pieces');
    var qtyLabel = qty === 1 ? ('1 ' + unitOne) : (qty + ' ' + unitMany);
    return '<div class="mm-vol-row' + (opts.active ? ' active' : '') + '" data-qty="' + qty + '" data-discount="' + (opts.discount || 0) + '" data-dtype="' + esc(opts.dtype || '') + '" role="button" tabindex="0">' +
      (opts.badge ? '<span class="mm-vol-badge-rec">' + esc(opts.badge) + '</span>' : '') +
      volRadioHtml(!!opts.active) +
      '<div class="mm-vol-row__main">' +
        '<div class="mm-vol-row__qty">' + qtyLabel + '</div>' +
        '<div class="mm-vol-row__meta">' +
          (opts.meta ? '<span class="mm-vol-row__sub">' + esc(opts.meta) + '</span>' : '') +
          (opts.disc ? '<span class="mm-vol-row__disc">' + esc(opts.disc) + '</span>' : '') +
        '</div>' +
      '</div>' +
      '<div class="mm-vol-row__price">' +
        (qty > 1 ? '<span class="mm-vol-row__price-label">' + esc(opts.totalLabel || 'Total') + '</span>' : '') +
        '<span class="mm-vol-row__price-val">' + esc(opts.price) + '</span>' +
      '</div>' +
    '</div>';
  }

  function startTimer(endsAt, tel, L, ar) {
    if (!endsAt || !tel) return;
    var et = new Date(endsAt).getTime();
    function tick() {
      var ms = et - Date.now();
      if (ms <= 0) { tel.textContent = L.expired || 'Expired'; return; }
      var days = Math.floor(ms / 86400000);
      var hrs = Math.floor((ms % 86400000) / 3600000);
      var mins = Math.floor((ms % 3600000) / 60000);
      var secs = Math.floor((ms % 60000) / 1000);
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      var text, delay;
      if (days >= 3) {
        text = days + (ar ? ' أيام ' : ' Days ') + p(hrs) + ':' + p(mins) + ':' + p(secs);
        delay = 60000;
      } else {
        text = p(days * 24 + hrs) + ':' + p(mins) + ':' + p(secs);
        delay = 1000;
      }
      tel.textContent = text;
      setTimeout(tick, delay);
    }
    tick();
  }

  window.MMOfferLandingUI = {
    esc: esc,
    variantImageUrl: variantImageUrl,
    updatePickerThumb: updatePickerThumb,
    setGalleryImage: setGalleryImage,
    filterVariants: filterVariants,
    buildVariantPickerHtml: buildVariantPickerHtml,
    wireVariantPickers: wireVariantPickers,
    buildChoiceGroupHtml: buildChoiceGroupHtml,
    buildFixedListHtml: buildFixedListHtml,
    volTierRow: volTierRow,
    startTimer: startTimer,
    closeAllPickers: closeAllPickers
  };
})();
